import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AuthenticationGuard = ({ children, requiredRole = null }) => {
  const location = useLocation();
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    userRole: null,
    isLoading: true,
  });

  useEffect(() => {
    const checkAuthentication = () => {
      const token = localStorage.getItem('authToken');
      const userRole = localStorage.getItem('userRole');

      if (token) {
        setAuthState({
          isAuthenticated: true,
          userRole: userRole,
          isLoading: false,
        });
      } else {
        setAuthState({
          isAuthenticated: false,
          userRole: null,
          isLoading: false,
        });
      }
    };

    checkAuthentication();
  }, []);

  if (authState?.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-shimmer w-64 h-8 rounded skeleton" />
      </div>
    );
  }

  if (!authState?.isAuthenticated) {
    return <Navigate to="/mobile-authentication" state={{ from: location }} replace />;
  }

  if (requiredRole && authState?.userRole !== requiredRole) {
    return <Navigate to="/registration-dashboard" replace />;
  }

  return <>{children}</>;
};

export default AuthenticationGuard;